<script lang="ts">
  import { defineComponent } from "vue";
  import SectionManualBillingDocumentList from '@/generated/sections/SectionManualBillingDocumentList.vue';
  import SectionManualBillingDocument from '@/extend/sections/SectionManualBillingDocumentExtend.vue';
  import ManualBillingDocument from '@/extend/classes/ManualBillingDocument';
  import Section from '@/framework/base/classes/Section';
  import { storeManualBillingDocument } from '@/generated/stores';

  export default defineComponent({
    extends: SectionManualBillingDocumentList,
    components: {},
    data() {
      return {
        selectedManualBillingDocument: new ManualBillingDocument(),
      };
    },
    computed: {
      section(): Section {
        const section = new Section();
        section.component = SectionManualBillingDocument;
        section.type = 'manualBillingDocument';
        section.data = this.selectedManualBillingDocument;
        section.ressource = this.ressource;
        section.autoSave = false;
        return section;
      },
    },
    methods: {
      addItem(): void {
        this.selectedManualBillingDocument =
          storeManualBillingDocument.createNewManualBillingDocument();
        this.selectedManualBillingDocument.effectiveAt = new Date();
        this.dialogOpen = true;
      },
      selectItem(event: unknown, row: { item: ManualBillingDocument }): void {
        this.openDocument(row.item);
      },
      updateItem(item: unknown): void {
        this.openDocument(item as ManualBillingDocument);
      },
      openDocument(item: ManualBillingDocument): void {
        this.selectedManualBillingDocument =
          storeManualBillingDocument.getManualBillingDocument(item.id);
        this.dialogOpen = true;
      },
      saved(): void {
        this.reloadTable();
      },
    },
  })
</script>
